import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";

// Number input that lets you type freely (e.g. "12") and only clamps/formats on blur or Enter.
export const NumField = ({ value, onCommit, min, max, step, decimals = 0, className, ...rest }) => {
  const fmt = (v) => (v == null || Number.isNaN(v) ? "" : decimals ? Number(v).toFixed(decimals) : String(Math.round(v)));
  const [text, setText] = useState(fmt(value));
  const [focused, setFocused] = useState(false);
  useEffect(() => { if (!focused) setText(fmt(value)); }, [value, focused]); // eslint-disable-line react-hooks/exhaustive-deps

  const clamp = (n) => { if (min != null) n = Math.max(min, n); if (max != null) n = Math.min(max, n); return n; };
  const commit = (raw) => {
    const n = parseFloat(raw);
    if (Number.isNaN(n)) { setText(fmt(value)); return; }
    const c = clamp(n);
    onCommit(c); setText(fmt(c));
  };
  return (
    <Input type="number" inputMode="decimal" min={min} max={max} step={step} value={text} className={className} {...rest}
      onFocus={(e) => { setFocused(true); e.target.select(); }}
      onChange={(e) => { const t = e.target.value; setText(t); const n = parseFloat(t); if (!Number.isNaN(n) && (min == null || n >= min)) onCommit(clamp(n)); }}
      onBlur={() => { setFocused(false); commit(text); }}
      onKeyDown={(e) => { if (e.key === "Enter") { e.currentTarget.blur(); } if (e.key === "ArrowUp" || e.key === "ArrowDown") { e.preventDefault(); const s = step || 1; const cur = parseFloat(text); const base = Number.isNaN(cur) ? (value ?? min ?? 0) : cur; commit(String(+(base + (e.key === "ArrowUp" ? s : -s)).toFixed(4))); } }} />
  );
};
